const initFaqAccordion = () => {
    const blocks = document.querySelectorAll('.block-faq__items');
    if (!blocks.length) return;

    blocks.forEach((block) => {
        const items = Array.from(block.querySelectorAll('.block-faq__item'));
        if (!items.length) return;

        const closeAll = () => {
            items.forEach((item) => {
                item.classList.remove('active');
                const answer = item.querySelector('.block-faq__item-answer');
                if (answer) answer.classList.remove('active');
            });
        };

        const openItem = (item) => {
            closeAll();
            item.classList.add('active');
            const answer = item.querySelector('.block-faq__item-answer');
            if (answer) answer.classList.add('active');
        };

        // Инициализация: если есть заранее активный элемент — открыть его и закрыть остальные
        const preActive = items.find(
            (item) =>
                item.classList.contains('active') ||
                item.querySelector('.block-faq__item-answer.active')
        );
        if (preActive) {
            openItem(preActive);
        }

        items.forEach((item) => {
            const title = item.querySelector('.block-faq__item-title');
            const icon = item.querySelector('svg');

            const toggle = (event) => {
                event.preventDefault();
                if (item.classList.contains('active')) {
                    closeAll();
                } else {
                    openItem(item);
                }
            };

            if (title) {
                title.addEventListener('click', toggle);
            }
            if (icon) {
                icon.addEventListener('click', toggle);
            }
        });
    });
};

document.addEventListener('DOMContentLoaded', initFaqAccordion);
export default initFaqAccordion;


